import styled from 'styled-components';
import { Theme } from '@commons/utils/theme';
export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.greys.darkest};
  background-image: url('/images/login.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
`;

export const SideBar = styled.div`
  box-sizing: border-box;
  width: 316px;
  height: 100%;
  padding: 48px;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const WhiteCard = styled.div`
  position: absolute;
  width: 560px;

  margin-left: 48px;

  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.greys.lighty};

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const TitleContainer = styled.div`
  box-sizing: border-box;

  width: 100%;
  height: 96px;

  border-radius: 16px 16px 0px 0px;
  border-bottom: 1px solid ${(props) => props.theme.colors.greys.lighty};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  padding: 24px;
`;

export const Title = styled.span`
  font: ${(props) => props.theme.fonts.h1Inter};
  color: ${(props) => props.theme.colors.greys.darkest};

  &:after {
    content: attr(data-text);
    color: ${(props) => props.theme.colors.brand.primary};
    transform: translateX(-100%);
    position: absolute;
  }
`;

export const ButtonContainer = styled.div`
  box-sizing: border-box;

  width: 100%;
  padding: 24px;
  gap: 8px;

  border-radius: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const getButtonStyle = (theme: Theme) => ({
  backgroundColor: theme.colors.greys.lightest,
  color: theme.colors.greys.darkest,
  border: `1px solid ${theme.colors.greys.darkest}`,
  borderRadius: '24px',
  textTransform: 'none',
  transition: 'color 0.3s ease, border-color 0.3s ease',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  '&:hover': {
    backgroundColor: theme.colors.greys.lightest,
    color: theme.colors.brand.primary,
    border: `1px solid ${theme.colors.brand.primary}`
  }
});
